import styled from "styled-components";

export const CalendlyContainer = styled.div`
 && {
   &.voa_overlay_59o7kg {
     position: fixed;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;
     background: rgba(0, 0, 0, 0.7);
     transition: opacity 100ms;
     display: none;
     opacity: 0;
     z-index: 9999994;
     &.show {
       display: block;
       opacity: 1;
     }
 
     .voa_close_59o7kg {
       position: absolute;
       top: 0px;
       right: 30px;
       transition: all 100ms;
       font-size: 40px;
       font-weight: bold;
       text-decoration: none;
       color: #FFFFFF;
       cursor:pointer;
       @media only screen and (max-device-width: 767px) {
         top: 40px;
       }
     }
   }
 
   .calendly-inline-widget {
      margin-top: 30px;
   }
 
   .details {
     margin: 70px auto;
     padding: 20px;
     background: none;
     border-radius: 5px;
     max-width: 320px;
     transition: all 1s ease-in-out;
     background-color: #FFFFFF;
     position:relative;
 
     .voa_close_59o7kg {
       position: absolute;
       top: 10px;
       right:10px;
       color: #000000;
       font-size:30px;
       cursor:pointer;
     }
 
     .content {
       font-family: inherit;
       padding:20px 0px;
       font-size: 15px;
     }
     .inline-buttons {
       display: flex;
       gap:20px;
       justify-content: center;
       .link {
         background: var(--primary-color);
         color: #FFFFFF;
         padding: 10px;
         min-width:70px;
         text-align: center;
         font-size:15px;
         text-decoration: none;
         border: none;
         border-radius: 5px;
       }
     }
   }
 }
`;